// extracted by mini-css-extract-plugin
export default {"author":"CEGMvpVOhWUhjZEnQk4W","btn":"QN7cvJ0pfzyEddKq5iMS"};